import React, { useContext } from 'react'
import { ContentInner } from '../../layout/Content'
import { Invoice8p5inchStyle, Invoice58mmStyle } from './css/InvoiceItemInnerStyle'
import PrinterSettingsStyle from '../../../css/PrinterSettingsStyle'
import { invoiceItemControllerContext } from './InvoiceItemController'
import { formatNumber } from '../../utilities/utilities'

function Invoice8p5inch() {
  const invoiceItemController = useContext(invoiceItemControllerContext)
  const { invoice, client } = invoiceItemController
  const paperSize = invoiceItemController.paperSize[0]

  return (
    <React.Fragment>
      <div className='report-wrapper'>
        <div id='invoice-8p5inch' className={(paperSize === '8.5inch') ? 'printable' : ''}>
          <div id='invoice-item-header'>
            <div id='invoice-item-header-left'>
              <div className='invoice-company-name-address-container'>
                <div><b>{client.company_profile.company_name}</b></div>
                <div>
                  {`
                    ${client.company_address.street},
                    ${client.company_address.zip_code} ${client.company_address.city},
                    ${client.company_address.state} ${client.company_address.country}
                  `}
                </div>
                <div>T.I.N: {client.company_profile.tin}</div>
                <div>Contact Number: {client.company_profile.contact_number}</div>
              </div>
              <div><b>Sales Invoice</b></div>
              <div><b>Invoice Number:</b> {invoice._id.toUpperCase()}</div>
              <div><b>Date/Time Created:</b> {new Date(invoice.date_time_created).toLocaleString("en-us", { timeZonze: invoice.client_timezone })} { invoice.client_timezone }</div>
              <div><b>Invoice Date</b> {new Date(invoice.invoice_date).toLocaleString("en-us", { timeZone: invoice.client_timezone }).split(',')[0]} { invoice.client_timezone }</div>
              <div><b>Prepared By:</b> {invoice.prepared_by}</div>
            </div>
          </div>

          {/* COSTUMERS'S DETAILS */}
          <table id='table-customer-details' className='table-invoice-item'>
            <tbody>
              <tr>
                <th style={{textAlign: 'left', width: '15%'}}>Sold To:</th>
                <td style={{width: '35%'}}>{invoice.customer_details.sold_to}</td>
                <th style={{textAlign: 'left', width: '10%'}}>Address:</th>
                <td style={{width: '40%'}}>{invoice.customer_details.address}</td>
              </tr>
              <tr>
                <th style={{textAlign: 'left', width: '15%'}}>Contact Number:</th>
                <td style={{width: '35%'}}>{invoice.customer_details.contact_number}</td>
                <th style={{textAlign: 'left', width: '10%'}}>Remarks: </th>
                <td style={{width: '40%'}}>{invoice.customer_details.remarks}</td>
              </tr>
            </tbody>
          </table>

          {/* IVOICE PARTICULARS */}
          <table id='table-item-paticulars' className='table-invoice-item'>
            <thead>
              <tr>
                <th style={{textAlign: 'left', width: '50%'}}>Item Name</th>
                <th style={{textAlign: 'left', width: '15%'}}>Unit</th>
                <th style={{textAlign: 'right'}}>Unit Price</th>
                <th style={{textAlign: 'center'}}>Quantity</th>
                <th style={{textAlign: 'right'}}>Amount</th>
              </tr>
            </thead>
            {
              invoice.invoice_particulars.map((item, index) => (
                <tbody key={index}>
                  <tr>
                    <td style={{textAlign: 'left'}}>{`${item.item_name} ${item.item_remarks}`}</td>
                    <td style={{textAlign: 'left'}}>{item.unit}</td>
                    <td style={{textAlign: 'right'}}>P{formatNumber(item.unit_price)}</td>
                    <td style={{textAlign: 'center'}}>{formatNumber(item.quantity)}</td>
                    <td style={{textAlign: 'right'}}>{`P${formatNumber(item.amount)} ${(item.vatable) ? 'V' : ''}`}</td>
                  </tr>
                </tbody>
              ))
            }
          </table>

          {/* INVOICE SUMMARY */}
          {/********************** VATed Sales *********************/}
          <div className='invoice-summary-container'>
            <div className='invoice-summary-item'>
              <div className='item-label'>Vatable Sales</div>
              <div id='invoice-vatable-sales' className='item-data'>
                P{formatNumber(invoice.invoice_summary.vat_total_sales - invoice.invoice_summary.vat_amount)}
              </div>
            </div>
            <div className='invoice-summary-item'>
              <div className='item-label'>VAT ({invoice.vat}%)</div>
              <div id='invoice-vat-amount' className='item-data'>
                P{formatNumber(invoice.invoice_summary.vat_amount)}
              </div>
            </div>
            <div className='invoice-summary-item'>
              <div className='item-label'>VATed Total Item(s)</div>
              <div id='invoice-vatable-sales' className='item-data'>
                {formatNumber(invoice.invoice_summary.vat_total_items)}
              </div>
            </div>
            <div className='invoice-summary-item'>
              <div className='item-label'>VATed Total Amount</div>
              <div id='invoice-vatable-sales' className='item-data'>
                P{formatNumber(invoice.invoice_summary.vat_total_sales)}
              </div>
            </div>
            <hr />

            {/**************** NONE VAT *******************/}
            <div className='invoice-summary-item'>
              <div className='item-label'>None-VAT Total Item(s)</div>
              <div id='invoice-vatable-sales' className='item-data'>
                {formatNumber(invoice.invoice_summary.none_vat_total_items)}
              </div>
            </div>
            <div className='invoice-summary-item'>
              <div className='item-label'>None-VAT Sales</div>
              <div id='invoice-vatable-sales' className='item-data'>
                P{formatNumber(invoice.invoice_summary.none_vat_total_sales)}
              </div>
            </div>
            <hr />

            {/****************** Total Sales *********************/}
            <div className='invoice-summary-item'>
              <div className='item-label'><b>Grand Total Item(s)</b></div>
              <div id='invoice-total-items' className='item-data'>
                <b>{formatNumber(invoice.invoice_summary.total_item)}</b>
              </div>
            </div>
            <div className='invoice-summary-item'>
              <div className='item-label'><b>Grand Total Sales</b></div>
              <div id='invoice-total-items' className='item-data'>
                <b>P{formatNumber(invoice.invoice_summary.total_sales)}</b>
              </div>
            </div>
          </div>
        </div>
        <Invoice8p5inchStyle />
        { (paperSize === '8.5inch') ? <PrinterSettingsStyle paperWidth='8.5inch'/> : null }
      </div>

      <div className='log-container'>
        <div className='created-by'>
          Created by {invoice.log.created_by.name} on {new Date(invoice.date_time_created).toLocaleString("en-us", { timeZone: invoice.client_timezone })} {invoice.client_timezone}
        </div>
        {
          (invoice.log.last_modified_by)
          ? <div className='last-modified-by'>
              Last modified by {invoice.log.last_modified_by.name} on {new Date(invoice.date_time_modified).toLocaleString("en-us", { timeZone: invoice.client_timezone })} {invoice.client_timezone}
            </div>
          : null
        }
      </div>
    </React.Fragment>
  )
}

function Invoice58mm() {
  const invoiceItemController = useContext(invoiceItemControllerContext)
  const { invoice, client } = invoiceItemController
  const paperSize = invoiceItemController.paperSize[0]

  return (
    <React.Fragment>
      <div id='invoice-58mm' className={(paperSize === '58mm') ? 'invoice-58mm printable' : 'invoice-58mm'}>
        <div id='invoice-58mm-header'>
          <div><b>{client.company_profile.company_name}</b></div>
          <div>
            {`
              ${client.company_address.street},
              ${client.company_address.zip_code} ${client.company_address.city},
              ${client.company_address.state} ${client.company_address.country}
            `}
          </div>
          <div>T.I.N: {client.company_profile.tin}</div>
          <div>Contact Number: {client.company_profile.contact_number}</div>
          <div id='invoice-details-container'>
            <div style={{textAlign: 'center'}}><b>Sales Invoice</b></div>
            <div><b>Invoice Number</b></div><div>{invoice._id.toUpperCase()}</div>
            <div><b>Date/Time Created</b></div><div>{new Date(invoice.date_time_created).toLocaleString("en-us", { timeZone: invoice.client_timezone })} { invoice.client_timezone }</div>
            <div><b>Invoice Date</b></div><div>{new Date(invoice.invoice_date).toLocaleString("en-us", { timeZone: invoice.client_timezone })} { invoice.client_timezone }</div>
            <div><b>Prepared By</b></div><div>{invoice.prepared_by}</div>
            <div className={(invoice.customer_details.sold_to) ? 'invoice-details-show' : 'invoice-details-hide'}>
              <div><b>Sold To</b></div><div>{invoice.customer_details.sold_to}</div>
            </div>
            <div className={(invoice.customer_details.address) ? 'invoice-details-show' : 'invoice-details-hide'}>
              <div><b>Customers Address</b></div><div>{invoice.customer_details.address}</div>
            </div>
            <div className={(invoice.customer_details.contact_number) ? 'invoice-details-show' : 'invoice-details-hide'}>
              <div><b>Customers Contact Number</b></div><div>{invoice.customer_details.contact_number}</div>
            </div>
            <div className={(invoice.customer_details.remarks) ? 'invoice-details-show' : 'invoice-details-hide'}>
              <div><b>Remarks</b></div><div>{invoice.customer_details.remarks}</div>
            </div>
          </div>
        </div>

        <div style={{textAlign: 'center'}}><b>*** ITEMS LIST ***</b></div>
        <div className='items-list'>
        {
          invoice.invoice_particulars.map((ip, index) => (
            <div key={index} className='item-wrapper'>
              <div>{index+1}) {ip.item_name}</div>
              <div>{`${ip.quantity} ${ip.unit} @P${formatNumber(ip.unit_price)} -> P${formatNumber(ip.amount)} ${(ip.vatable) ? 'V' : ''}`}</div>
              <div style={{display: ((index + 1) === invoice.invoice_particulars.length) ? 'none' : 'block'}}>---</div>
            </div>
          ))
        }
        </div>

        {/* INVOICE SUMMARY */}
        {/********************** VATed Sales *********************/}
        <div className='invoice-summary-container fifty-eight-mm'>
          <div className='invoice-summary-item'>
            <div className='item-label'>Vatable Sales</div>
            <div id='invoice-vatable-sales' className='item-data'>
              P{formatNumber(invoice.invoice_summary.vat_total_sales - invoice.invoice_summary.vat_amount)}
            </div>
          </div>
          <div className='invoice-summary-item'>
            <div className='item-label'>VAT ({invoice.vat}%)</div>
            <div id='invoice-vat-amount' className='item-data'>
              P{formatNumber(invoice.invoice_summary.vat_amount)}
            </div>
          </div>
          <div className='invoice-summary-item'>
            <div className='item-label'>VATed Total Item(s)</div>
            <div id='invoice-vatable-sales' className='item-data'>
              {formatNumber(invoice.invoice_summary.vat_total_items)}
            </div>
          </div>
          <div className='invoice-summary-item'>
            <div className='item-label'>VATed Total Amount</div>
            <div id='invoice-vatable-sales' className='item-data'>
              P{formatNumber(invoice.invoice_summary.vat_total_sales)}
            </div>
          </div>
          <hr />

          {/**************** NONE VAT *******************/}
          <div className='invoice-summary-item'>
            <div className='item-label'>None-VAT Total Item(s)</div>
            <div id='invoice-vatable-sales' className='item-data'>
              {formatNumber(invoice.invoice_summary.none_vat_total_items)}
            </div>
          </div>
          <div className='invoice-summary-item'>
            <div className='item-label'>None-VAT Sales</div>
            <div id='invoice-vatable-sales' className='item-data'>
              P{formatNumber(invoice.invoice_summary.none_vat_total_sales)}
            </div>
          </div>
          <hr />

          {/**************** Total Sales ***************/}
          <div className='invoice-summary-item'>
            <div className='item-label'><b>Grand Total Item(s)</b></div>
            <div id='invoice-total-items' className='item-data'>
              <b>{formatNumber(invoice.invoice_summary.total_item)}</b>
            </div>
          </div>
          <div className='invoice-summary-item'>
            <div className='item-label'><b>Grand Total Sales</b></div>
            <div id='invoice-total-items' className='item-data'>
              <b>{formatNumber(invoice.invoice_summary.total_sales)}</b>
            </div>
          </div>
        </div>
      </div>
      <Invoice58mmStyle />
      { (paperSize === '58mm') ? <PrinterSettingsStyle paperWidth='58mm'/> : null }
    </React.Fragment>
  )
}

function InvoiceItemInner() {
  return (
    <ContentInner>
      <Invoice8p5inch />
      <Invoice58mm />
    </ContentInner>
  )
}

export default React.memo(InvoiceItemInner)